export const dataEnv = () => {
  return {
    API_URL: process.env['API_URL'] || 'https://gcp.nateevo.com/api/v1'
  };
  if (process.env.NODE_ENV === "telamarinera") {
    return {
      API_URL: "http://gcp.loaasssaasascal:3000/api/v1",
    };
  } else if (process.env.NODE_ENV === "pepitogrillo") {
    return {
      // API_URL: "https://gcp-api.nateevo.com/api/v1",
      API_URL: "http://gcp.aaaaaaa:3000/api/v1",
    };
  } else {
    return {
      API_URL: "http://gcp.local:3000/api/v1"
    };
  }
};
